import React, { useState, useEffect, useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import up1 from '../../img/Home/up1.webp';
import up2 from '../../img/Home/up2.webp';
import up3 from '../../img/Home/up3.webp';

function UpgradeToComposite () {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);
    const [rotationDirection, setRotationDirection] = useState('rotate-left');
    const intervalRef = useRef(null);  // Для хранения интервала
    const timeoutRef = useRef(null);   // Для хранения таймаута

    const data = [
        {
            title: t('home.19'),
            img: up1,
        },
        {
            title: t('home.20'),
            img: up2,
        },
        {
            title: t('home.21'),
            img: up3,
        },
    ];

    useEffect(() => {
        const images = [up1, up2, up3];
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    useEffect(() => {
        setRotationDirection(prev => prev === 'rotate-left' ? 'rotate-right' : 'rotate-left');
    }, [active]);

    // Функция запуска автопереключения
    const startAutoSlide = () => {
        intervalRef.current = setInterval(() => {
            setActive(prev => (prev + 1) % data.length);
        }, 5000);
    };

    useEffect(() => {
        startAutoSlide(); // Первый запуск

        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
        };
    }, []);

    // Обработчик ручного переключения
    const handleManualChange = (index) => {
        setActive(index);

        // Останавливаем автослайд
        clearInterval(intervalRef.current);
        clearTimeout(timeoutRef.current);

        // Перезапускаем с задержкой 15 секунд
        timeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 15000);
    };

    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <p className="text-[#F26522] open-sans text-[28px] xl:text-[30px] xl:hidden block"><Trans>{t('home.22')}</Trans></p>
                <div className="flex items-center justify-between mt-[50px] xl:mt-0">
                    <div className="flex flex-col w-[350px] xl:w-auto">
                        {data.map((item, index) => (
                            <div className="flex cursor-pointer items-center" key={index} onClick={() => handleManualChange(index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <circle cx="4" cy="4.69873" r="4" fill={active === index ? '#F26522' : ''}/>
                                </svg>
                                <p className={`text-[#F26522] open-sans text-[23px] sm:text-[28px] transition-all ml-[7px] ${active === index ? '' : 'opacity-[0.25]'}`}>0{index+1}</p>
                                <p className={`ml-[15px] text-[#F6F6F6] open-sans text-[14px] sm:text-[20px] transition-all ${active === index ? '' : 'opacity-[0.25]'}`}>{item.title}</p>
                            </div>
                        ))}
                    </div>
                    <div className="relative">
                        <div className={`absolute inset-0 transition-opacity duration-1000 ${active !== 0 ? 'opacity-50' : 'opacity-0'}`}>
                            <img src={data[(active + 2) % 3].img} alt="" className="w-full h-auto object-cover"/>
                        </div>
                        <div className={`image-rotate-wrapper ${rotationDirection}`} key={active}>
                            <img src={data[active].img} alt="" className="w-full h-auto object-cover"/>
                        </div>
                    </div>
                    <p className="text-[#F26522] open-sans text-[28px] xl:text-[30px] hidden xl:block"><Trans>{t('home.22')}</Trans></p>
                </div>
            </div>
        </div>
    );
}

export default UpgradeToComposite;
